module.exports = __webpack_public_path__ + "img/morley.62ef1b0a.svg";